import AgeInfo from 'src/components/base-components/AgeInfo';
import Auth from 'src/components/base-components/Auth';
import BackToTop from 'src/components/base-components/BackToTop';
import Balance from 'src/components/base-components/Balance';
import BlogWidget from 'src/components/base-components/BlogWidget';
import BottomNavigation from 'src/components/base-components/BottomNavigation';
import CopyRight from 'src/components/base-components/CopyRight';
import Deposit from 'src/components/base-components/Deposit';
import Ebac from 'src/components/base-components/Ebac';
import GambleAware from 'src/components/base-components/GambleAware';
import GameBoxToggle from 'src/components/base-components/GameBoxToggle';
import GameTags from 'src/components/base-components/GameTags';
import GosWidget from 'src/components/base-components/GosWidget';
import HighestWinsTable from 'src/components/base-components/HighestWinsTable';
import { HomeWidgetsWrapper } from 'src/components/base-components/HomeWidgets/HomeWidgetsWrapper';
import Language from 'src/components/base-components/Language';
import LegalNotice from 'src/components/base-components/LegalNotice';
import Licence from 'src/components/base-components/Licence';
import { Logo } from 'src/components/base-components/Logo';
import MailButton from 'src/components/base-components/MailButton';
import { Navigation } from 'src/components/base-components/Navigation';
import NewsLetter from 'src/components/base-components/NewsLetter';
import Mobile_Menu_Button from 'src/components/base-components/OnlyMobileComponents/Mobile_Menu_Button';
import OperatorBlock from 'src/components/base-components/OperatorBlock';
import Promotion from 'src/components/base-components/Promotion';
import ProviderBlock from 'src/components/base-components/ProviderBlock';
import ProviderFilter from 'src/components/base-components/ProviderFilter';
import RaceWidget from 'src/components/base-components/RaceWidget';
import ReferAFriendWidget from 'src/components/base-components/ReferAFriendWidget';
import ResponsibleGaming from 'src/components/base-components/ResponsibleGaming';
import Search from 'src/components/base-components/Search';
import SideBarNavigation from 'src/components/base-components/SideBarNavigation/SideBarNavigation';
import SideBarPromotion from 'src/components/base-components/SideBarPromotion/SideBarPromotion';
import SideBarToggle from 'src/components/base-components/SideBarToggle';
import Slider from 'src/components/base-components/Slider';
import HomePageGamesSliders from 'src/components/base-components/Slider/HomePageGamesSlider/HomePageGamesSliders';
import SocialNetworks from 'src/components/base-components/SocialNetworks';
import Stories from 'src/components/base-components/Stories/Stories';
import TagRow from 'src/components/base-components/TagRow/TagRow';
import TermsBriefInfo from 'src/components/base-components/TermsBriefInfo';
import UserSettings from 'src/components/base-components/UserSettings';
import WinReplays from 'src/components/base-components/WinReplays/WinReplays';
import { lazyWidget } from 'src/configs/components/lazyWidget';

const Address_Input = lazyWidget(() => import('src/components/common/Address_Input'));
const AntiMoneyLaunderingPolicy = lazyWidget(() => import('src/components/common/AntiMoneyLaunderingPolicy'));
const BankAccountType_Select = lazyWidget(() => import('src/components/common/BankAccountType_Select'));
const BankCode_Input = lazyWidget(() => import('src/components/common/BankCode_Input'));
const BankName_Select = lazyWidget(() => import('src/components/common/BankName_Select'));
const BirthDate_Input = lazyWidget(() => import('src/components/common/BirthDate_Input'));
const BlockOfPrivacyPolicy = lazyWidget(() => import('src/components/common/BlockOfPrivacyPolicy'));
const CPF_Input = lazyWidget(() => import('src/components/common/CPF_input'));
const City_Input = lazyWidget(() => import('src/components/common/City_Input'));
const Country_Select = lazyWidget(() => import('src/components/common/Country_Select'));
const Currency_Select = lazyWidget(() => import('src/components/common/Currency_Select.tsx'));
const DNI_Input = lazyWidget(() => import('src/components/common/DNI_Input'));
const Email_Input = lazyWidget(() => import('src/components/common/Email_Input'));
const Employment_Select = lazyWidget(() => import('src/components/common/Employment_Select'));
const FirstName_Input = lazyWidget(() => import('src/components/common/FirstName_Input'));
const Gender_Select = lazyWidget(() => import('src/components/common/Gender_Select'));
const ID_Main_Issue_Input = lazyWidget(() => import('src/components/common/ID_Main_Issue_Input'));
const Ip_Input = lazyWidget(() => import('src/components/common/Ip_Input'));
const LastName_Input = lazyWidget(() => import('src/components/common/LastName_Input'));
const NationalId_input = lazyWidget(() => import('src/components/common/NationalId_input'));
const Nationality_Input = lazyWidget(() => import('src/components/common/Nationality_Input'));
const NotificationsEnabled = lazyWidget(() => import('src/components/common/NotificationsEnabled'));
const ParentId = lazyWidget(() => import('src/components/common/ParentId_Input'));
const Password_Input = lazyWidget(() => import('src/components/common/Password_Input'));
const Phone_Number_Input = lazyWidget(() => import('src/components/common/Phone_Number_Input'));
const Poker = lazyWidget(() => import('src/components/base-components/Poker'));
const Province_Input = lazyWidget(() => import('src/components/common/Province_Input'));
const Repeat_Password_Input = lazyWidget(() => import('src/components/common/Repeat_Password_Input'));
const SafePromo = lazyWidget(() => import('src/components/base-components/SafePromo'));
const TaxId_Input = lazyWidget(() => import('src/components/common/TaxId_Input'));
const TermsConditionsPolicy = lazyWidget(() => import('src/components/common/TermsConditionsPolicy'));
const Username_Input = lazyWidget(() => import('src/components/common/Username_Input'));
const ZipCode_Input = lazyWidget(() => import('src/components/common/ZipCode_Input'));
const bankAccount_Input = lazyWidget(() => import('src/components/common/BankAccount_Input'));

export const Components: any = {
  highestWinsTable: HighestWinsTable,
  gosWidget: GosWidget,
  raceWidget: RaceWidget,
  stories: Stories,
  winReplays: WinReplays,
  socials: SocialNetworks,
  logo: Logo,
  languages: Language,
  promotions: Promotion,
  authorization: Auth,
  deposit: Deposit,
  balance: Balance,
  useSettings: UserSettings,
  headerNavigation: Navigation,
  slider: Slider,
  blog: BlogWidget,
  search: Search,
  providerFilter: ProviderFilter,
  gameTags: GameTags,
  menu: Mobile_Menu_Button,
  sideBarNavigation: SideBarNavigation,
  sideBarToggle: SideBarToggle,
  promotionSections: SideBarPromotion,
  gameBoxToggle: GameBoxToggle,
  referAFriendToggle: ReferAFriendWidget,
  tagRow: TagRow,
  mailButton: MailButton,

  //footer
  copyRight: CopyRight,
  bottomNavigation: BottomNavigation,
  operatorBlock: OperatorBlock,
  licence: Licence,
  ageInfo: AgeInfo,
  providerBlock: ProviderBlock,
  backToTop: BackToTop,
  gambleAware: GambleAware,
  ebac: Ebac,
  termsBriefInfo: TermsBriefInfo,
  responsibleGaming: ResponsibleGaming,
  legalNotice: LegalNotice,

  // registration
  cpf: CPF_Input,
  username: Username_Input,
  password: Password_Input,
  password2: Repeat_Password_Input,
  email: Email_Input,
  phoneNumber: Phone_Number_Input,
  currency: Currency_Select,
  firstname: FirstName_Input,
  lastname: LastName_Input,
  parentId: ParentId,
  address: Address_Input,
  ip: Ip_Input,
  city: City_Input,
  zipCode: ZipCode_Input,
  bankAccountNumber: bankAccount_Input,
  bankCode: BankCode_Input,
  province: Province_Input,
  bankName: BankName_Select,
  bankAccountType: BankAccountType_Select,
  taxId: TaxId_Input,
  nationalId: NationalId_input,
  country: Country_Select,
  residency: Country_Select,
  employment: Employment_Select,
  birthDate: BirthDate_Input,
  nationality: Nationality_Input,
  gender: Gender_Select,
  dni: DNI_Input,
  idMainIssue: ID_Main_Issue_Input,
  termsConditionsPolicy: TermsConditionsPolicy,
  antiMoneyLaunderingPolicy: AntiMoneyLaunderingPolicy,
  notificationsEnabled: NotificationsEnabled,
  generalBlockOfTermsAndConditions: BlockOfPrivacyPolicy,

  homeWidgetsWrapper: HomeWidgetsWrapper,
  newsLetter: NewsLetter,
  homePageGamesSliders: HomePageGamesSliders,
  poker: Poker,
  safePromo: SafePromo,
};
